var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClasses,attrs:{"type":_vm.type,"disabled":_vm.submitting}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }